
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import ConnectionReport from "../components/connectionReport";
import Footer from "../components/footer";

function ConnectionReportPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <ConnectionReport /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default ConnectionReportPage;
